/* eslint-disable no-undef */
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';

import LocaleContext from 'constants/localization';
import Types from 'constants/types';

import Header from 'field/common/Header';
import CreateResourceButton from 'field/edit/resource/CreateResourceButton';
import EditLinkedResources from 'field/edit/resource/EditLinkedResources';

// SPEC-86, add Objects from Acquisition
const BuiltSiteBuildingsEdit = (props) => {
  const { field, actionError } = props;
  const uri = useSelector(state => state.object.uri);
  const LS = useContext(LocaleContext);

  const openCreate = () => {
    const params = encodeURIComponent(`addContent.do?&view=${Types.SPECTRUM.CE.BUILDING_VIEW}&builtSite=${uri}`);
    window.open(`index.do?main_action=${params}`, '_blank');
  };

  const openEdit = e => {
    const index = getInputIndex(e);
    const uri = field.values[index].uri;
    window.open(`index.do?main_action=editObject.do?uri=${uri}`, '_blank');
  };

  return (
    <div className="field">
      <Header field={field} />
      <CreateResourceButton
        onCreate={openCreate}
        label={LS.target}
        style={{ marginBottom: '1rem' }} />
      <EditLinkedResources
        onEdit={openEdit}
        values={field.values} />
    </div>
  );
};

export default BuiltSiteBuildingsEdit;